import { render, staticRenderFns } from "./imageAndText.vue?vue&type=template&id=4d8a25c8&scoped=true&"
import script from "./imageAndText.vue?vue&type=script&lang=js&"
export * from "./imageAndText.vue?vue&type=script&lang=js&"
import style0 from "./imageAndText.vue?vue&type=style&index=0&id=4d8a25c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a25c8",
  null
  
)

export default component.exports